import { useRef, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setCredentials, setPBICredentials, selectCurrentUser } from './authSlice'
import { Avatar, Typography } from "@mui/material";
import { deepOrange, deepPurple } from '@mui/material/colors';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useLoginMutation, usePbiLoginMutation } from './authApiSlice'
import Spinner from '../../components/Spinner'
import './login.scss'
import { useSelector } from 'react-redux'
import PrivacyPolicyDialog from './PrivacyPolicy';
import BottomFooter from '../../components/BottomFooter';

const Login = () => {
    const userRef = useRef()
    const errRef = useRef()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [errMsg, setErrMsg] = useState('')
    const navigate = useNavigate()

    const [login, { isLoading }] = useLoginMutation()
    const [pbiLogin, { isPbiLoginLoading }] = usePbiLoginMutation()
    const dispatch = useDispatch()
    const user = useSelector(selectCurrentUser)
    const [openPopup, setOpenPopup] = useState(false)

    useEffect(() => {
        userRef.current.focus()
    }, [])

    useEffect(() => {
        setErrMsg('')
    }, [username, password])



    //For Login Bypass local development - Starts
    // const handleLoginBypass = async () => {
    //     try {
    //         const reqData = { "loginId": username, "IntelligenceUsername": "PRDMIGROS", "IntelligencePassword": "gvq344HdF" }
    //         const userData = await pbiLogin(reqData).unwrap()
    //         let newUserData = { "Token": userData && userData.token ? userData.token : "" }
    //         dispatch(setCredentials({ ...newUserData, username }))
    //         setUsername('')
    //         setPassword('')
    //         setTimeout(() => {
    //             navigate('/home')
    //         }, 10);
    //     } catch (err) {

    //     }
    // }
    //For Login Bypass local development - Ends

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            const userData = await login({ username, password }).unwrap()
            localStorage.setItem('userdata', JSON.stringify({ ...userData, username }));
            sessionStorage.setItem('sessionStartTime', Date.now());
            dispatch(setCredentials({ ...userData, username }))
            setUsername('')
            setPassword('')
            navigate('/home')
        } catch (err) {
            //For Login Bypass local development - Starts
            // handleLoginBypass()
            //For Login Bypass local development - Ends
            if (!err?.originalStatus) {
                // isLoading: true until timeout occurs
                setErrMsg('No Server Response');
            } else if (err.originalStatus === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.originalStatus === 401) {
                setErrMsg('Unauthorized');
            } else {
                setErrMsg('Login Failed');
            }
            errRef.current.focus();
        }
    }

    const handleUserInput = (e) => setUsername(e.target.value)

    const handlePwdInput = (e) => setPassword(e.target.value)

    const content = (
        <div className="login-page">
            <div className='logo'>
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAAAiCAYAAABoZDaJAAADPElEQVR42u1aS3LbMAzNtrt202Unk0iabtKhlFVWzRF6g/QG7Q3aGzQ3iG/QbrNIZE9murVv0N7AukFLSKRNgeBHoSI5GbwZLkxSIIgHggDHR0cMBoPBYDAYDMbB4C47P8XtMXMY4+Lh7OwNZXOyf5mX/3DDAmPmMMZFXVTfKZuT/Uwik8h4aSTWx+L1fVZ+XGXiW9ty8QV+D97Ae3Hcyon8Xs9t1yzEVZ0LcajkxOo6OYlAHigl+7fUXNn+1IX4FFIS5izz6ob4fk1tFowBskNrglNQc0BvtE+Q1SyL8q9vrtTlszUu18Djq7xcDtV1NhLl77q3oby6bomVm8D9PiU9m4RW99fskw2G6wxYXVP9q6L8ZRk+q77u9MnEZTe/XGAZppxujXLhG9drafnRupr6pJKoSDGbk0RCaGN4pLANJy49JG7AoykHML0dNtsbkyfH53SgR3fK7RNuGR7mKkL7MsqFId+KOPA9Hu9kDdd1LBKDTYdRvCEzhFBK6s2S4VQRHBrHJ5ZYc0MR0IZKiuB9uN0YMvDcrcsxezbZjzcxutrRqtM1mUSYaDanwoR3h0j0KRNDInVKQobZE0CFSRk+1VrBkCn3a50sx3gXlm3Co3Wd6k6kBM5BYnTkoBOcrU5oeskL4aBAjDY6ecca4+AQSbpORiLhlTOR2MC6vubxfOvOM64KZ+KlHKLxjafoOiGJ4dBGbSKJxIgQ5a1BifIAlwg42bGaSk6c4+puTdF10hIDe2OIRN/FHZ3YoDrOZRgwItSvvbuuO2FN5Pc04apUCo2n6DopiURI3XrvFV0mJJBIyF1ThtHlkVl/UUmLSTJ+OXIlMJ6Qi/bxOF2nf7GxMrnqRoWStbNgTiCRXDOrfsKTVvusVYgrbRTK81GYa3xhDZcr+PWGCqn2esN1neXttA0txHPVrog3CBiDxJ2Xu9aU/fgEUuSYoS/mbsJOgSORWfSn6DqIxNFf39WLx64RCcOTrdnWaV3yg95Yf6hSotanSJ+OKfQboivDYTTrIUO9NA3JahlzkojKoDYcyTvJfKdkPAMQyUfjykgZB4zb0w9v4U9FDyfn735fXLxiizAYDAaDwWAwGE+B//hP6FZWGmyRAAAAAElFTkSuQmCC" />
                <Typography
                    className='logotitle'
                    variant="h6"
                    sx={{ m: "0 0 5px 0" }}
                >
                    &nbsp; Enacto Analytics
                </Typography>
            </div>
            <div className="login-form-wrap">
                <form className="loginform" onSubmit={handleSubmit}>
                    <div className="form-box">
                        <Avatar className='marginauto' sx={{ bgcolor: deepPurple[500] }}><LockOutlinedIcon /></Avatar>
                        <h3 className='marginauto signinlbl'>Sign in</h3>
                        <label htmlFor="username">Username:</label>
                        <input
                            type="text"
                            id="username"
                            ref={userRef}
                            value={username}
                            onChange={handleUserInput}
                            autoComplete="off"
                            required
                        />

                        <label htmlFor="password">Password:</label>
                        <input
                            type="password"
                            id="password"
                            onChange={handlePwdInput}
                            value={password}
                            required
                        />
                        <br />
                        {/* <FormControlLabel className='lbllogin1' control={<Checkbox />} label="Remember me" /> */}
                        <br />
                        <button>Login</button>
                        <div>
                            <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
                        </div>
                        <div className='privacy-policy'> <a href="#" onClick={() => setOpenPopup(true)}><b>Privacy</b></a></div>
                        {/* By logging into our application you agree to our */}
                    </div>
                </form>
                <BottomFooter />
            </div>
            {isLoading && (<Spinner />)}
            {openPopup && (<PrivacyPolicyDialog open={openPopup} onClose={() => setOpenPopup(false)} />)}
        </div>
    )

    return content
}
export default Login


